import { MeterLink } from 'components/link/MeterLink';
import { Flex } from 'antd';
import type { FC } from 'react';
import type { SerializedInventoryMeter } from '@enmon/commons/lib/tools';
import { MergedMeterLink } from '../../link/MergedMeterLink';

export const MeterIdCell: FC<{
  inventoryMeterId: number | string;
  enmonMeterId: string;
  isActive: boolean;
  mergedAt: SerializedInventoryMeter['merged_at'];
  mergedIntoId: SerializedInventoryMeter['merged_into']['id'];
}> = ({ inventoryMeterId, enmonMeterId, isActive, mergedAt, mergedIntoId }) => (
  <Flex gap={16} justify="end">
    {mergedAt && mergedIntoId && <MergedMeterLink mergedIntoId={mergedIntoId} />}
    {Boolean(enmonMeterId) && isActive && <MeterLink backend_gateway_meter_id={enmonMeterId} />} {inventoryMeterId}
  </Flex>
);
